import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import DIDs from '../components/DIDs'

export default class DIDsHome extends Component {
    render() {
        return (
            <div style={styles.container}>
                <DIDs />
                <div style={{textAlign: "center", paddingTop: "2.5vh"}}>
                    <h1>
                        MARKETING CONTENT GOES HERE
                    </h1>
                </div>
                <div style={styles.fixedBottomRightHolder}>
                    <div style={styles.btnsHolder} className="btns-holder">
                        <Link to="/shop/phone-numbers">
                            <div className="btn">
                                Continue In Shop
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    container: {
        marginTop: "5vh",
        padding: "0 2.5vw",
    }, 
    fixedBottomRightHolder: {
        position: "fixed",
        right: "0",
        bottom: "0",
    },
    btnsHolder: {
        margin: ".75rem 1rem",
    }
}